import React from 'react';
import styles from './Input.module.css';
import { useLocation } from 'react-router-dom';

type InputType = {
  label: string;
  type: string;
  name: string;
  value?: string | undefined;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  error?: string | null;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  placeholder?: string | undefined;
  maxLength?: number | undefined;
  classe?: string;
  anexo?: boolean;
  disabled?: boolean;
};

const Input = ({
  label,
  type,
  name,
  value,
  onChange,
  error,
  onBlur,
  placeholder,
  maxLength,
  classe,
  anexo,
  disabled,
}: InputType) => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div
      className={`${
        classe ? `${classe} ${styles.wrapper}` : `${styles.wrapper}`
      }`}
    >
      <label className={styles.label} htmlFor={name}>
        {label}
      </label>
      <input
        placeholder={placeholder}
        id={name}
        name={name}
        className={styles.input}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        maxLength={maxLength}
        disabled={
          anexo ||
          (disabled &&
            !pathname.includes('novo-medico-pre') &&
            !pathname.includes('profissionais') &&
            !pathname.includes('nova-clinica-pre'))
            ? true
            : false
        }
      />
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};

export default Input;
